import { type SVGProps } from 'react'
import { cn } from '@/lib/cn'

export interface LogoProps extends SVGProps<SVGSVGElement> {
  size?: number
}

/**
 * HUN TECH Monogram Logo
 * Geometric architectural emblem:
 * Dual pillars representing structural integrity, united by an elevated
 * upward chevron and apex summit — embodying the ethos of "Above All" (Hundaol).
 */
export function Logo({ className, size = 28, ...props }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0 text-fg', className)}
      aria-hidden="true"
      {...props}
    >
      {/* Left Monolith */}
      <rect x="5" y="5" width="5" height="22" rx="0.75" fill="currentColor" />

      {/* Right Monolith */}
      <rect x="22" y="5" width="5" height="22" rx="0.75" fill="currentColor" />

      {/* Apex Chevron ("Above All" Crossbeam) */}
      <path
        d="M8 17L16 9.8L24 17V22L16 16.2L8 22V17Z"
        fill="currentColor"
      />

      {/* Summit Marker */}
      <circle cx="16" cy="4.9" r="1.9" fill="currentColor" />
    </svg>
  )
}
